export const AD_TYPE_APP = 'APP广告';
export const AD_TYPE_PC = 'PC广告';